import React, { useState,useEffect } from 'react';
import './MukurtamPage.css';

function MukurtamPage() {
  const [selectedStar, setSelectedStar] = useState('Ashwini');
  const [message, setMessage] = useState('No data yet');
  const [panchangamData, setPanchangamData] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState('english');
  const [selectedLocation, setSelectedLocation] = useState('chennai');

  useEffect(() => {
    // Load preferences from localStorage on component mount
    const savedLanguage = localStorage.getItem('language');
    const savedLocation = localStorage.getItem('location');
    if (savedLanguage) setSelectedLanguage(savedLanguage);
    if (savedLocation) setSelectedLocation(savedLocation);
  }, []);

  useEffect(() => {
    // Save preferences to localStorage whenever they change
    localStorage.setItem('language', selectedLanguage);
    localStorage.setItem('location', selectedLocation);
  }, [selectedLanguage, selectedLocation]);

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  const handleLocationChange = (event) => {
    setSelectedLocation(event.target.value);
  }

  const handleStarChange = (event) => {
    setSelectedStar(event.target.value);
  };
  const getColorClass = (value) => {
    switch (value.toLowerCase()) {
      case 'good':
        return 'good';
      case 'neutral':
        return 'neutral';
      case 'avoid':
        return 'avoid';
      default:
        return '';
    }
  };

  const labels = {
    english: {
      heading: 'Panchangam',
      aboutPage: 'Indain calendar which is also referred as panchangam is more than just simple calendar. This focus on right time for doing thngs , from simple decision to life changing events like marrige etc.. . Generally this right time is called mukurtham.Applyting the basic rules of panchangam below screen is tailoured to show auspicous days for given users star',
      selectStar: 'Select Star:',
      tamilDate: 'Tamil Date',
      star: 'Star',
      thithi: 'Thithi',
      karna: 'Karna',
      apply: 'Apply',
      noData: 'No data yet',
      misc1: 'Till'
    },
    tamil: {
      heading: 'பஞ்சாங்கம்',
      aboutPage: 'பஞ்சாங்கம் என்றும் குறிப்பிடப்படும் இந்திய நாட்காட்டி எளிய நாட்காட்டியை விட அதிகம். எளிமையான முடிவு முதல் திருமணம் போன்ற வாழ்க்கையை மாற்றும் நிகழ்வுகள் வரை, விஷயங்களைச் செய்வதற்கான சரியான நேரத்தில் கவனம் செலுத்துகிறது. பொதுவாக இந்த சரியான நேரம் முகூர்த்தம் என்று அழைக்கப்படுகிறது.பஞ்சாங்கத்தின் அடிப்படை விதிகளை கீழே உள்ள திரையில் பயன்படுத்துவது, கொடுக்கப்பட்ட பயனரின் நட்சத்திரத்திற்கான நல்ல நாட்களைக் காட்ட வடிவமைக்கப்பட்டுள்ளது.',
      selectStar: 'நட்சத்திரத்தை தேர்ந்தெடுக்கவும்:',
      tamilDate: 'தமிழ் தேதி',
      star: 'நட்சத்திரம்',
      thithi: 'திதி',
      karna: 'கரணம்',
      apply: 'விண்ணப்பிக்க',
      noData: 'தகவல் எதுவும் இல்லை',
      misc1: 'வரை'
    },
  };
  const starOptions = {
    english: [
      "Aswini", "Bharani", "Karthigai", "Rohini", "Mrigasirisha", "Thiruvathirai", 
      "Punarpoosam", "Poosam", "Ayilyam", "Magam", "Pooram", "Uthiram", "Hastham", 
      "Chithirai", "Swathi", "Visagam", "Anusham", "Kettai", "Moolam", "Pooradam", 
      "Uthiradam", "Thiruvonam", "Avittam", "Sadayam", "Poorattathi", "Uthirattathi", 
      "Revathi"
    ],
    tamil: [
      "அஸ்வினி", "பரணி", "கார்த்திகை", "ரோகிணி", "மிருகசீரிஷம்", "திருவாதிரை", 
      "புனர்பூசம்", "பூசம்", "ஆயில்யம்", "மகம்", "பூரம்", "உத்திரம்", "ஹஸ்தம்", 
      "சித்திரை", "சுவாதி", "விசாகம்", "அனுசம்", "கேட்டை", "மூலம்", "பூராடம்", 
      "உத்திராடம்", "திருவோணம்", "அவிட்டம்", "சதயம்", "பூரட்டாதி", "உத்திரட்டாதி", 
      "ரேவதி"
    ]
  };
  

  const fetchPanchangamData = () => {
    const bodyData = {
      star: selectedStar,  // Use dynamic star selected
      language: selectedLanguage,
      location: selectedLocation,
    };
  
    fetch('https://zqpfgqimf6.execute-api.ap-south-1.amazonaws.com/Stage1/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(bodyData),
    })
    .then((response) => {
      if (response.status !== 200) {
        return Promise.reject(`Error: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      console.log(data)
      setPanchangamData(data);
      setMessage(`You selected ${selectedStar}. Panchangam data loaded.`);
    })
    .catch((error) => {
      console.error('Error fetching Panchangam data:', error);
    });
  };

  const handleApplyClick = () => {
    fetchPanchangamData();
  };

  return (
    <div className="mukurtam-page">
            <div className="preferences-bar">
        <select value={selectedLanguage} onChange={handleLanguageChange}>
          <option value="english">English</option>
          <option value="tamil">Tamil</option>
        </select>
        <select value={selectedLocation} onChange={handleLocationChange}>
          <option value="chennai">Chennai</option>
          {/* Add more locations as needed */}
        </select>
      </div>
      <h1>{labels[selectedLanguage].heading}</h1>
      <p>{labels[selectedLanguage].aboutPage}</p>
      <div className="dropdown-container">
        <label htmlFor="star-select">{labels[selectedLanguage].selectStar}:</label>
        <select id="star-select" value={selectedStar} onChange={handleStarChange}>
        {starOptions[selectedLanguage].map((star) => (
            <option key={star} value={star}>{star}</option>
          ))}
        </select>
        <button onClick={handleApplyClick}>{labels[selectedLanguage].apply}</button>
      </div>
     
      {/* Display panchangamData below if available */}
      {panchangamData && (
        <div className="info-boxes">
        <div className="info-box">
          <span className="label">{labels[selectedLanguage].tamilDate}</span>
          <span className="value">{panchangamData.tamilday} {selectedLanguage === 'tamil' ? panchangamData.tamilmonth[0] : panchangamData.tamilmonth[1]} {panchangamData.tamilyear}</span>
          <span className="value">{selectedLanguage === 'tamil' ? panchangamData.paksha[0] : panchangamData.paksha[1]}</span>
        </div>
        <div className="info-box">
          <span className="label">{labels[selectedLanguage].star}</span>
          <span className={`value ${getColorClass(panchangamData.star1[1])}`}>
          {selectedLanguage === 'tamil' ? (<>
        {panchangamData.star1[0][0]}  {panchangamData.star1[2]} {labels[selectedLanguage].misc1} </>) : (<>
        {panchangamData.star1[0][1]} {labels[selectedLanguage].misc1} {panchangamData.star1[2]} </>)}

          </span>
          {panchangamData.star2  ? (
            <span className={`value ${getColorClass(panchangamData.star2[1])}`}>
            {selectedLanguage === 'tamil' ? panchangamData.star2[0][0] : panchangamData.star2[0][1]}
            </span>
          ) : null}
        </div>
        <div className="info-box">
          <span className="label">{labels[selectedLanguage].thithi}</span>
          <span className={`value ${getColorClass(panchangamData.thithi1[1])}`}>
          {selectedLanguage === 'tamil' ? (<>
          {panchangamData.thithi1[0][0]}  {panchangamData.thithi1[2]} {labels[selectedLanguage].misc1} </>) : (<>
          {panchangamData.thithi1[0][1]} {labels[selectedLanguage].misc1} {panchangamData.thithi1[2]} </>)}  
          
          </span>
          <span className={`value ${getColorClass(panchangamData.thithi2[1])}`}>
          {selectedLanguage === 'tamil' ? panchangamData.thithi2[0][0] : panchangamData.thithi2[0][1]} 
          </span>
        </div>
        <div className="info-box">
          <span className="label">{labels[selectedLanguage].karna}</span>
          <span className={`value ${getColorClass(panchangamData.karnam1[1])}`}>
          {selectedLanguage === 'tamil' ? panchangamData.karnam1[0][0] : panchangamData.karnam1[0][1]}
          </span>
        </div>
      </div>
      )}
    </div>
  );
}

export default MukurtamPage;
